<span [hidden]="!text" *ngIf="text!='N/A'"> {{ text | date: "dd-MMM-yyyy" }}</span>
<span [hidden]="!text" *ngIf="text=='N/A'"> {{ text }}</span>